<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">结算报表名称</span>
        <Input v-model="searchParams.reportName" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">待结算</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="addNewReport">新建结算报表</Button>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reportName">
          <span class="table-btn" @click="toDetailPage(row)">{{ row.reportName }}</span>
        </template>
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">待结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="delRow(row)">删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  data() {
    return {
      searchParams: {},
      total: null,
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '报表名称',
          align: 'center',
          key: 'reportName',
          minWidth: 180,
          slot: 'reportName'
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '批单数',
          align: 'center',
          key: 'billNum',
          minWidth: 100
        },
        {
          title: '保费合计',
          align: 'center',
          key: 'fee',
          minWidth: 140
        },
        {
          title: '投保保费',
          align: 'center',
          key: 'insureFee',
          minWidth: 140
        },
        {
          title: '批改保费',
          align: 'center',
          key: 'billFee',
          minWidth: 140
        },
        {
          title: '退保保费',
          align: 'center',
          key: 'refundFee',
          minWidth: 140,
          render(h, params) {
            return <span>{params.row.refundFee ? params.row.refundFee : 0}</span>;
          }
        },
        {
          title: '基础费用合计',
          align: 'center',
          key: 'baseLeaderAmount',
          minWidth: 140
        },
        {
          title: '业务员基础费用合计',
          align: 'center',
          key: 'baseIncome',
          minWidth: 140
        },
        {
          title: '团队长管理费合计',
          align: 'center',
          key: 'baseLeaderIncome',
          minWidth: 140
        },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          width: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ],
      tableData: []
    };
  },

  created() {
    this.getList();
  },

  methods: {
    resetSearch() {
      this.searchParams = {};
      this.searchParams.date = [];
      this.searchAjax();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      if (data.date && data.date.length > 0) {
        data.settlementDateStart = data.date[0];
        data.settlementDateEnd = data.date[1];
      }
      delete data.date;
      this.$http({
        url: '/buz/userSettlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 3
        }
      })
        .then(res => {
          this.total = res.total;
          res.data.map(item => {
            item.baseLeaderAmount = (Number(item.baseIncome) + Number(item.baseLeaderIncome)).toFixed(2);
          });
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 详情
    toDetailPage(row) {
      let step = row.step;
      if (step == 1) {
        this.openPageTabTags('/financialManage/groupFinanceSettlement/editReport', {
          reportId: row.id,
          isAdd: 0,
          step: '1',
          reportName: row.reportName
        });
      } else {
        this.openPageTabTags('/financialManage/groupFinanceSettlement/editReport', {
          reportId: row.id,
          reportName: row.reportName,
          step,
          settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD') //结算日期
        });
      }
    },

    // 删除
    delRow(row) {
      if(!this.$units.pointAction('offline_81_3_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/userSettlementReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },

    // 新建结算报表
    addNewReport() {
      if(!this.$units.pointAction('offline_81_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.openPageTabTags('/financialManage/groupFinanceSettlement/newReport', {
        isAdd: 1,
        step: '1',
        reportName: '新建结算报表',
        time: Date.now()
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}
</style>
